import styled from 'styled-components'

export const StyledBoxButton = styled.div`

  button {
    margin: 0 auto;
  }
`